// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------Tag Printing page Styling ----------------------------------- */

.check-box {
    display: flex;
}

input {
    background-color: transparent;
    border-color: white;
    color: white;
    outline: none;
    border: 1px solid white;
    padding: 5px;
    border-radius: 10px;
}

input::placeholder {
    color: white;
}

input[type="checkbox"] {
    width: 20px;
}

/* ------------ Capture Page Styling --------------------------- */

.main {
    display: grid;
    /* grid-template-columns: 15% 15% 15% 15% 10% 10% 1fr; */
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    margin-bottom: 0%;
    grid-gap: 10px;
    /* padding-left: 20px; */
    padding: 2%;
    align-items: center;
    width: 100%;
}


.colorSet {
    color: white;
}


.data {
    width: 100%;
    padding: 10px;
    min-height: 45px;
    border-radius: 5px;
    background-color: #373E43;
    border: 1px solid white;
    color: white;
}

.main button {
    margin-top: 35px;
}

.active-table-btn-link {

    color: white;
}

.active-table-btn {
    width: 30px;
    display: flex;
    justify-content: center;
    background-color: #0069D9;
    list-style: none;
    border-radius: 5px;
}


.active-table-btn::marker,
previous-table-btn::marker,
next-table-btn::marker {
    display: none;
}

.previous-table-btn-link {
    width: 100px;
    display: flex;
    color: white;
    border-radius: 5px;
    justify-content: center;
    background-color: #0069D9;
    list-style: none;
    border: none;
}

.previous-table-btn-link:hover{
    color: #fff;
    text-decoration: none;
}

.previous-table-btn-link:focus{
    color: #fff;
    text-decoration: none;
    background-color: #0652a3;
}



.ul-main {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    border-radius: 20px;
    margin-top: 20px;
    background-color: rgb(96, 96, 96);
    height: 40px;
    align-items: center;
    list-style: none;
    grid-column-gap: 30px;
    padding-right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/screens/TagIT/css/tagPrinting.css"],"names":[],"mappings":"AAAA,2FAA2F;;AAE3F;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,kEAAkE;;AAElE;IACI,aAAa;IACb,wDAAwD;IACxD,4DAA4D;IAC5D,iBAAiB;IACjB,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,WAAW;AACf;;;AAGA;IACI,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;;;IAGI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;;;AAIA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":["/* -------------------------Tag Printing page Styling ----------------------------------- */\n\n.check-box {\n    display: flex;\n}\n\ninput {\n    background-color: transparent;\n    border-color: white;\n    color: white;\n    outline: none;\n    border: 1px solid white;\n    padding: 5px;\n    border-radius: 10px;\n}\n\ninput::placeholder {\n    color: white;\n}\n\ninput[type=\"checkbox\"] {\n    width: 20px;\n}\n\n/* ------------ Capture Page Styling --------------------------- */\n\n.main {\n    display: grid;\n    /* grid-template-columns: 15% 15% 15% 15% 10% 10% 1fr; */\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    margin-bottom: 0%;\n    grid-gap: 10px;\n    /* padding-left: 20px; */\n    padding: 2%;\n    align-items: center;\n    width: 100%;\n}\n\n\n.colorSet {\n    color: white;\n}\n\n\n.data {\n    width: 100%;\n    padding: 10px;\n    min-height: 45px;\n    border-radius: 5px;\n    background-color: #373E43;\n    border: 1px solid white;\n    color: white;\n}\n\n.main button {\n    margin-top: 35px;\n}\n\n.active-table-btn-link {\n\n    color: white;\n}\n\n.active-table-btn {\n    width: 30px;\n    display: flex;\n    justify-content: center;\n    background-color: #0069D9;\n    list-style: none;\n    border-radius: 5px;\n}\n\n\n.active-table-btn::marker,\nprevious-table-btn::marker,\nnext-table-btn::marker {\n    display: none;\n}\n\n.previous-table-btn-link {\n    width: 100px;\n    display: flex;\n    color: white;\n    border-radius: 5px;\n    justify-content: center;\n    background-color: #0069D9;\n    list-style: none;\n    border: none;\n}\n\n.previous-table-btn-link:hover{\n    color: #fff;\n    text-decoration: none;\n}\n\n.previous-table-btn-link:focus{\n    color: #fff;\n    text-decoration: none;\n    background-color: #0652a3;\n}\n\n\n\n.ul-main {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    border-radius: 20px;\n    margin-top: 20px;\n    background-color: rgb(96, 96, 96);\n    height: 40px;\n    align-items: center;\n    list-style: none;\n    grid-column-gap: 30px;\n    padding-right: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
